import { QueryClientProvider } from "@tanstack/react-query";
import { type ReactNode, useState } from "react";
import { I18nextProvider } from "react-i18next";
import { Toaster } from "sonner";

import { ApiClientProvider } from "@/api/client-provider";
import { SpiffAuthProvider } from "@/auth/spiff-auth-provider";
import { initI18n } from "@/lib/i18n/i18n";
import { ThemeProvider } from "@/lib/theme/theme-provider";

import { createQueryClient } from "./query-client";

const i18n = initI18n();

export function AppProviders({ children }: { children: ReactNode }) {
  // レンダ本体で new すると再生成されキャッシュが飛ぶ（oxlint の
  // @tanstack/query/stable-query-client が error で検出する）
  const [queryClient] = useState(createQueryClient);

  return (
    <I18nextProvider i18n={i18n}>
      <QueryClientProvider client={queryClient}>
        <ThemeProvider>
          <SpiffAuthProvider>
            <ApiClientProvider>
              {children}
              <Toaster richColors position="top-right" />
            </ApiClientProvider>
          </SpiffAuthProvider>
        </ThemeProvider>
      </QueryClientProvider>
    </I18nextProvider>
  );
}
